import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9455a3b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product flex-row-center"
};
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'HBoxList',
  props: {
    count: {
      type: Number,
      default: 10
    },
    interval: {
      type: Number,
      default: 3000
    },
    gap: {
      type: Number,
      default: 10
    },
    width: {
      type: Number,
      default: 1000
    },
    singleWidth: {
      type: Number,
      default: 290
    },
    type: {
      type: String,
      default: 'pc'
    }
  },
  setup(__props) {
    const props = __props;
    const listRef = ref(null);
    let index = 0;
    let timeoutId = 0;
    const onClickLeft = () => {
      //console.log('onClickLeft')
      index++;
      if (index >= props.count) {
        index = props.count - 1;
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(prePic, props.interval);
      } else {
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(nextPic, props.interval);
      }
      //console.log(index)
      /*console.log(listRef.value.children[index])
      const el=listRef.value&&listRef.value.children[index] as HTMLElement
      console.log(el)
      if(el)*/
      listRef.value && listRef.value.scrollTo({
        left: props.singleWidth * index,
        behavior: 'smooth'
      });
    };
    const onClickRight = () => {
      //console.log('onClickRight')
      index--;
      if (index < 0) {
        index = 0;
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(nextPic, props.interval);
      } else {
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(prePic, props.interval);
      }
      /*console.log(listRef.value.children[index])
      const el=listRef.value&&listRef.value.children[index] as HTMLElement
      if(el)*/
      listRef.value && listRef.value.scrollTo({
        left: props.singleWidth * index,
        behavior: 'smooth'
      });
    };
    const nextPic = () => {
      onClickLeft();
      timeoutId = setTimeout(nextPic, props.interval);
    };
    const prePic = () => {
      onClickRight();
      timeoutId = setTimeout(prePic, props.interval);
    };
    onMounted(() => {
      timeoutId = setTimeout(nextPic, props.interval);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "arrow left",
        onClick: onClickLeft
      }), _createElementVNode("div", {
        class: _normalizeClass(["scroll-x list-container flex-row", __props.type == 'pc' ? '' : 'flex-full']),
        ref_key: "listRef",
        ref: listRef,
        style: _normalizeStyle(__props.type == 'pc' ? 'width:' + __props.width + 'px;gap:' + __props.gap + 'px;' : 'gap:' + __props.gap + 'px;')
      }, [_renderSlot(_ctx.$slots, "default")], 6), _createElementVNode("div", {
        class: "arrow right",
        onClick: onClickRight
      })]);
    };
  }
});